<script>
import Table from '@/views/backstageSupport/components/table/index.vue'
const tableField = [
  {
    dataIndex: 'legal_date',
    key: 'legal_date',
    title: '法律信息公开日',
    width: 100
  },
  {
    dataIndex: 'event_details',
    key: 'event_details',
    title: '法律信息',
    width: 180
  },
  {
    dataIndex: 'event_status',
    key: 'event_status',
    title: '法律信息详情',
    width: 115
  }
]
// 获取表单的传入值
function tablePropsConfig(total, tableValue) {
  return {
    options: tableField,
    tableValue,
    rowSelection: null,
    otherOpt: {
      pagination: {
        pageSize: 5,
        pageNum: 1,
        total: 0
      }
    }
  }
}
// 处理数据转为表单配置
function handleResultToTable(h) {
  const { content } = this.instance
  const v = content.法律信息.reduce((list, cur) => {
    list.push(JSON.parse(cur))
    return list
  }, [])
  return h('Table', {
    ref: 'table',
    class: 'law-table-wrap',
    props: tablePropsConfig(v.length, v)
  })
}

export default {
  name: 'LawInfo',
  components: { Table },
  props: {
    instance: Object
  },
  render(h) {
    const resultNode = handleResultToTable.call(this, h)
    return resultNode
  }
}
</script>
